
    import * as React from 'react';

    const ChevronLeft60 = ({ color = 'currentcolor', height = '60px', width = '60px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 60 60" fill="none" style={svgStyle}><path fillRule="evenodd" clipRule="evenodd" d="M21 30.3258L38.4611 50.6516L39.2196 50L22.3183 30.3258L39.2196 10.6516L38.4611 10L21 30.3258Z" /></svg>
        </div>
      );
    };

    ChevronLeft60.displayName = 'ChevronLeft60';

    export default ChevronLeft60;
  